import { memo } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { CircularLoader } from "@similarweb/ui-components";

import { Flex } from "@similarweb/ui-components/foundations";

const CardLoader = () => {
    return (
        <Flex
            data-automation="card-loader"
            flexGrow={1}
            justifyContent="center"
            alignItems="center"
            minHeight="208px"
        >
            <CircularLoader
                options={{
                    svg: {
                        stroke: colorsPalettes.midnight["50"],
                        strokeWidth: "4",
                        r: 21,
                        cx: "50%",
                        cy: "50%",
                    },
                    style: {
                        width: 46,
                        height: 46,
                    },
                }}
            />
        </Flex>
    );
};

export default memo(CardLoader);
